import * as yup from "yup";
const phoneRegex = /^(010|011|012|015)\d{8}$/;

export const validationSchemaAr = yup.object({
  name: yup
    .string()
    .min(3, "الاسم يجب أن يكون على الأقل 3 حروف")
    .required("الاسم مطلوب"),
  email: yup
    .string()
    .email("بريد إلكتروني غير صالح")
    .required("البريد الإلكتروني مطلوب"),
  // avatar: yup.string(),
  refContact: yup.object({
    name: yup.string().nullable(),

    // .required("اسم جهة الاتصال مطلوب"),
    phone: yup
      .string()
      .matches(
        phoneRegex,
        "رقم الهاتف غير صالح، يجب أن يكون 11 رقم ويبدأ بـ 010 أو 011 أو 012 أو 015"
      )
      .nullable(),

    // .required("رقم الهاتف لجهة الاتصال مطلوب"),
  }),
  secondPhone: yup
    .string()
    .matches(
      phoneRegex,
      "رقم الهاتف غير صالح، يجب أن يكون 11 رقم ويبدأ بـ 010 أو 011 أو 012 أو 015"
    )
    .nullable(),
  phone: yup
    .string()
    .matches(
      phoneRegex,
      "رقم الهاتف غير صالح، يجب أن يكون 11 رقم ويبدأ بـ 010 أو 011 أو 012 أو 015"
    )
    .nullable(),
  // nationalId: yup.string().required("الرقم القومي مطلوب"),
});
